<template>
  <m-dialog ref="dlg" @save="save" :title="informasi && informasi.id ? 'Ubah Informasi' : 'Tambah Informasi'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pa-5 mb-5">
            <v-card-text>
              <v-row wrap class="mx-2">
                <v-col cols="12" sm="12" md="6" lg="6" class="pt-0 mt-0">
                  <v-autocomplete
                    clearable
                    outlined
                    dense
                    :disabled="disableForm"
                    autocomplete="off"
                    name="Seri"
                    :items="itemSeri"
                    placeholder="Semua Seri"
                    label="Pilih Seri"
                    hint="Jika tidak memilih seri maka informasi akan ditampilkan diberanda pilih instansi"
                    persistent-hint
                    v-model="informasi.instansi"
                    data-vv-name="seri"
                    data-vv-as="Seri"
                    item-text="nama"
                    item-value="id"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="pt-0 mt-0">
                  <v-select
                    outlined
                    dense
                    :disabled="disableForm"
                    autocomplete="off"
                    name="Jenis"
                    :items="itemJenisInfos"
                    placeholder="Semua Jenis"
                    label="Pilih Model Informasi"
                    persistent-hint
                    v-model="informasi.jenis"
                    data-vv-name="jenis"
                    data-vv-as="Model Informasi"
                    item-text="keterangan"
                    item-value="id"
                    return-object
                    v-validate="'required'"
                    :error-messages="errors.collect('form.jenis')"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12" class="py-0 my-0">
                  <v-text-field
                    outlined
                    dense
                    autocomplete="false"
                    name="Judul"
                    placeholder="Isikan Judul"
                    label="Judul"
                    v-model="informasi.judul"
                    persistent-hint
                    data-vv-name="judul"
                    data-vv-as="Judul"
                    v-validate=""
                    :error-messages="errors.collect('form.judul')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12" v-show="!disableForm">
                  <v-textarea
                    outlined
                    dense
                    autocomplete="false"
                    name="informasi"
                    placeholder="Isikan Informasi"
                    label="Informasi"
                    v-model="informasi.informasi"
                    persistent-hint
                    data-vv-name="informasi"
                    data-vv-as="Informasi"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.informasi')"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    outlined
                    autocomplete="false"
                    name="Konfigurasi"
                    placeholder="JSON Konfigurasi digunakan untuk overide komponen dialog"
                    label="JSON Konfigurasi"
                    v-model="informasi.opsi"
                    persistent-hint
                    data-vv-name="opsi"
                    data-vv-as="Konfigurasi"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="grey lighten-3">
                  <span class="title black--text">Pratinjau</span>
                  <v-divider class="py-4"></v-divider>
                  <div v-html="informasi.informasi"></div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      step: 1,
      itemJenisInfos: [
        { id: 1, keterangan: "Alert" },
        { id: 2, keterangan: "Pop Up" }
      ],
      informasi: {},
      defInformasi: {
        instansi_id: 0,
        judul: "",
        informasi: "null",
        status: 1
      },
      disableForm: false,
      alert: ALERT_INFO,
      itemSeri: []
    };
  },
  methods: {
    // @vuese
    // Membuka dialog tambah atau edit informasi, jika terdapat objek maka dialog yang terbuka adalah untuk edit dan jika objek kosong maka dialog yang terbuka adalah untuk tambah (baru) informasi
    // @args objek informasi
    open(obj) {
      this.loadSeri();

      if (obj) {
        this.informasi = { ...obj };
        this.informasi.opsi = JSON.stringify(obj.opsi);
      } else {
        this.informasi = { ...this.defKelas };
      }
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    // @vuese
    // Mengambil daftar seri untuk ditampilkan dalam Pilihan Diklat
    loadSeri() {
      return this.$store
        .dispatch("instansi/get", this.instansi_id)
        .then(res => {
          this.itemSeri = res;
          this.disableForm = false;
        })
        .catch(e => e);
    },

    // @vuese
    // Menyimpan informasi
    save() {
      if (!this.informasi.instansi) {
        this.informasi.instansi_id = 0;
        this.informasi.instansi = {
          id: 0,
          nama: "Semua Seri"
        };
      }
      this.informasi.instansi_id = this.informasi.instansi.id;
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.informasi.opsi = JSON.parse(this.informasi.opsi);
          return this.$store
            .dispatch("informasi/form", {
              obj: this.informasi
            })
            .then(res => {
              this.$refs.dlg.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>
